import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledSearchForm = styled(Box)`
  display: flex;
  align-items: center;
  height: ${props => props.theme.layout(36)};
  
  .SearchForm {
    &-button {
      margin-left: ${props => props.theme.layout('1sp')};
    }
    &-form {
      .FormControl {
        flex-grow: 1;
        .MuiInputBase-root {
          .MuiInputBase-input {
            padding: 0;
          }
          .MuiInputAdornment-positionStart {
            margin-left: 0;
          }
        }
      }
    }
  }
  ${ComponentStyles}
`;

StyledSearchForm.propTypes = {
  theme: PropTypes.object
};

export default StyledSearchForm;
